module.exports = __webpack_public_path__ + "static/media/29DUNON11.d341cc51.jpg";